import React, { useEffect, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import '../../less/floating-error.less';
import { GradingUrlsContext } from '../grading/grading-view';
export const FloatingErrorContext = createContext(() => { });
export const FloatingError = ({ currentError, showButtons = true }) => {
    useEffect(() => {
        document.body.style.overflow = currentError ? 'hidden' : 'auto';
    }, [currentError]);
    const { t } = useTranslation();
    const gradingUrls = useContext(GradingUrlsContext);
    if (!currentError)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "disabled-background", tabIndex: -1 }),
        React.createElement("div", { id: "floating-error" },
            React.createElement("div", { className: "error-symbol" }, "\u26A0"),
            React.createElement("div", { className: "message localized-error", dangerouslySetInnerHTML: { __html: t(currentError) } }),
            showButtons && (React.createElement(React.Fragment, null,
                React.createElement("button", { id: "logout-on-error", onClick: () => window.location.assign(gradingUrls.logout()) }, t('sa.logout')),
                React.createElement("button", { id: "reload-page", onClick: () => location.reload() }, t('arpa.errors.reload_page')))))));
};
//# sourceMappingURL=floating-error.js.map